import React from 'react';
import styles from './StoreHomePage.module.scss';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';

const StoreHomePage = () => {
    const {t} = useTranslation();

    return (
        <div className={styles.store_homepage_container}>
            <div className={styles.store_contents}>
                {/* <div className={styles.title}>{t('TOWER_WEBSTORE_BANNER_TITLE')}</div>
                <div className={styles.description}>{t('TOWER_WEBSTORE_BANNER_DESCRIPTION')}</div>
                
                <Link to="/store" className={styles.follow_btn}>
                    <span>{t('GO_TO_WEB_STORE')}</span>
                </Link> */}

                <div className={styles.medium_title}> 
                    Trade TOWER NFT Collections in OnePlanet to Get Exclusive Achievement Badge
                </div>
                <div className={styles.stay_tuned}>Stay Tuned!</div>

                <div className={styles.links_container}>
                    <a href="https://www.oneplanetnft.io/collections/items/0xcf501ead3ebfa60f40725fca1d82fc05bff63bf2" target="_blank" rel="noopener noreferrer"
                        className={styles.follow_btn}
                    >
                        <span>Trade TOWER Battle Card</span>
                    </a>
                    <a href="https://www.oneplanetnft.io/collections/items/0x2b88ce7b01e6bdbb18f9703e01286608cf77e805" target="_blank" rel="noopener noreferrer"
                        className={styles.follow_btn}
                    >
                        <span>Trade TOWER Treasury</span>
                    </a>
                </div>
            </div>
        </div>
    );
}

export { StoreHomePage };